import React, { useState } from 'react';
import {
    Toolbar, // Use Toolbar directly for structure
    InputBase,
    IconButton,
    Box,
    useTheme,
    useMediaQuery,
} from '@mui/material';
import { Search, FilterList, Add, FilterListOff } from '@mui/icons-material';
import MDButton from 'components/MDButton';
import ProjectCreation from 'layouts/projects/Components/ProjectCreation';
import useDialogHook from 'hooks/useDialogHook';
import FilterDialog from 'layouts/projects/Pages/All/SearchBar/filterDialog';
import { useSearch } from 'layouts/projects/Pages/SearchProvider';

// Project colors from palette
const colors = {
    primary: '#e91e63', // Primary - Pink
    secondary: '#7b809a', // Secondary
    dark: '#344767', // Dark
    darkGradient: '#191919', // Dark Gradient end
    light: '#f0f2f5', // Light
    lightNeutral100: '#f8f9fa', // Light Neutral 100
    lightNeutral300: '#dee2e6', // Light Neutral 300
    lightNeutral500: '#adb5bd', // Light Neutral 500
    lightNeutral600: '#6c757d', // Light Neutral 600
    lightNeutral900: '#212529', // Light Neutral 900
    success: '#4CAF50', // Success
    white: '#ffffff',
};

function AdvancedSearch() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { open, handleClickOpen, handleClose } = useDialogHook();
    const [newProject, setNewProject] = useState(false);
    const { searchQuery, updateSearchQuery, resetFilters } = useSearch();

    return (
        // Box container with dark background using the dark color from palette
        <Box
            sx={{
                borderRadius: 1,
            }}
        >
            <Toolbar
                disableGutters
                variant="dense"
                sx={[{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 1.5,
                    width: '100%',
                    minHeight: '48px',
                    px: 0.5,
                    py: 0.75,
                    backgroundColor: 'transparent'
                }, isMobile ? {
                    flexDirection: 'column'
                } : {
                    flexDirection: 'row'
                }]}
            >
                {/* Search Input Section */}
                <Box
                    sx={[{
                        display: 'flex',
                        alignItems: 'center',
                        flex: 1,
                        backgroundColor: colors.light,
                        borderRadius: 1.5,
                        border: `1px solid ${"var(--colors-lightNeutral300)"}`,
                        p: '4px 8px'
                    }, isMobile ? {
                        width: '100%'
                    } : {
                        width: 'auto'
                    }]}
                    style={{
                        "--colors-lightNeutral300": colors.lightNeutral300
                    }}>
                    <IconButton sx={{ p: '6px', color: colors.lightNeutral600 }} aria-label="search">
                        <Search fontSize="small" />
                    </IconButton>
                    <InputBase
                        sx={{
                            ml: 1,
                            flex: 1,
                            color: colors.lightNeutral900,
                            fontSize: '0.9rem',
                            '& ::placeholder': {
                                color: colors.lightNeutral500,
                                opacity: 1,
                            },
                        }}
                        placeholder="Projelerde ve Müşterilerde Ara..."
                        value={searchQuery}
                        onChange={(e) => updateSearchQuery(e.target.value)}
                        inputProps={{ 'aria-label': 'projelerde ve müşterilerde ara' }}
                    />
                </Box>

                {/* Action Buttons Section */}
                <Box
                    sx={[{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5
                    }, isMobile ? {
                        width: '100%'
                    } : {
                        width: 'auto'
                    }, isMobile ? {
                        justifyContent: 'space-between'
                    } : {
                        justifyContent: 'flex-end'
                    }]}
                >
                    <IconButton
                        onClick={resetFilters}
                        size="small"
                        sx={{ color: colors.lightNeutral100 }}
                        title="Filtreleri Temizle"
                    >
                        <FilterListOff fontSize="small" />
                    </IconButton>

                    <IconButton
                        onClick={handleClickOpen}
                        size="small"
                        sx={{ color: colors.lightNeutral100 }}
                        title="Filtrele"
                    >
                        <FilterList fontSize="small" />
                    </IconButton>

                    <MDButton
                        startIcon={<Add sx={{ fontSize: '1rem' }} />}
                        variant="contained"
                        onClick={() => setNewProject(!newProject)}
                        size="small"
                        color="primary" // Utilizing Material-UI's color system with your theme colors
                        sx={{
                            whiteSpace: 'nowrap',
                            fontSize: '0.8rem',
                            padding: '4px 12px',
                            borderRadius: 1.5,
                            ml: 1,
                            textTransform: 'none',
                            boxShadow: 'none',
                        }}
                    >
                        Yeni Proje
                    </MDButton>
                </Box>
            </Toolbar>
            {/* Dialogs */}
            {open && <FilterDialog open={open} handleClose={handleClose} />}
            {newProject && <ProjectCreation />}
        </Box>
    );
}

export default AdvancedSearch;
